export default __webpack_public_path__ + "static/media/Q16_0_resized.7c816436.jpg";